
















































































import Vue from 'vue';
import { TaskType, getTaskDesc } from '../models/TaskType';
import Filters from '../../customer/vuex/filters';
import customerVuex from '../../customer/vuex/common';
import { CustomerFilter } from '../../customer/models/CustomerFilter';
import format from '../../customer/components/filter/makeCustomerQuery';
import CustomerFilterDisplayBox from '../../mass/components/mpgroup/CustomerFilterDisplayBox.vue';
import Task from '../models/Task';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    CustomerFilterDisplayBox,
  },
  props: {
    task: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      TaskType,
    };
  },
  computed: {
    customerFilter(): CustomerFilter {
      const query = this.task.taskInput.CustomerExport.query;
      return format.query2Filter(query);
    },
    filterNothing(): boolean {
      const filter = this.customerFilter;
      return !Filters.isFilterSex(filter) &&
        !Filters.isFilterSubscribe(filter) &&
        !Filters.isFilterArea(filter) &&
        !Filters.isFilterSubscribeScene(filter) &&
        !Filters.isFilterInteract(filter) &&
        !Filters.isFilterTrace(filter) &&
        !Filters.isFilterScore(filter) &&
        !Filters.isFilterScoreSum(filter) &&
        !Filters.isFilterMember(filter) &&
        !Filters.isFilterGroup(filter) &&
        !Filters.isFilterTopics(filter) &&
        !Filters.isFilterRemark(filter) &&
        !Filters.isFilterCustom(filter);
    },
  },
  methods: {
    displayTaskName(task: Task): string {
      return getTaskDesc(task.taskType);
    },
  },
});
